export default __webpack_public_path__ + "static/media/BannersMoto_raceweekCanada_330x330.d9337313.jpg";